<h1 *ngIf="title" class="font-card-header">
  {{ title }}
</h1>
<ng-container *ngIf="!loading; else loadingState">
  <div class="fw-well" *ngIf="editable">
    <p *ngIf="!managedByLdap">{{ 'fwContainerPermissions.addUser' | translate }}</p>
    <p *ngIf="managedByLdap" class="font-error">{{ 'fwContainerPermissions.managedByLdap' | translate }}</p>
    <p *ngIf="showPropagate">{{ 'fwContainerPermissions.propagateProjects' | translate }}</p>
    <form [formGroup]="addPermission" class="add-permission">
      <app-typeahead
        test-id="user-typeahead"
        class="solid-background"
        formControlName="user"
        [placeholder]="'fwContainerPermissions.user' | translate"
        [options]="eligibleUsers">
      </app-typeahead>
      <mat-form-field *ngIf="!isAccess" class="solid-background" appearance="outline" style="width: 256px">
        <mat-select test-id="user-role-select" formControlName="roles"
          [placeholder]="'fwContainerPermissions.roles' | translate" [multiple]="!isAccess">
          <mat-option *ngFor="let option of permissionOptions" [attr.test-id]="'select-option-' + option.label"
            [disabled]="$any(option).disabled" [value]="option.value">
            {{ option.label || option.value }}
          </mat-option>
        </mat-select>
        <mat-error>
          {{ 'fwContainerPermissions.errors.required' | translate }}
        </mat-error>
      </mat-form-field>
      <mat-form-field *ngIf="isAccess" class="solid-background" appearance="outline">
        <mat-select test-id="user-access-select" formControlName="access"
          [placeholder]="'fwContainerPermissions.roles' | translate" [multiple]="!isAccess">
          <mat-option *ngFor="let option of permissionOptions" [disabled]="$any(option).disabled"
            [attr.test-id]="'select-option-' + option.label" [value]="option.value">
            {{ option.label || option.value }}
          </mat-option>
        </mat-select>
        <mat-error>
          {{ 'fwContainerPermissions.errors.required' | translate }}
        </mat-error>
      </mat-form-field>
      <mat-slide-toggle *ngIf="showPropagate" test-id="add-to-all-projects" formControlName="propagate">
        {{ 'fwContainerPermissions.togglePropagateProjects' | translate }}
      </mat-slide-toggle>
      <button mat-flat-button
        class="small"
        test-id="add-user"
        color="primary"
        [disabled]="addPermission.disabled || addPermission.invalid"
        (click)="add()">
        {{ 'common.actions.add' | translate }}
      </button>
    </form>
  </div>
  <ng-container *ngIf="dataSource?.data.length > 0; else emptyState">
    <div class="table-wrapper">
      <mat-table class="legacy-table" [dataSource]="dataSource">
        <ng-container matColumnDef="name">
          <th data-id="name" mat-header-cell *matHeaderCellDef>
            <mat-form-field appearance="outline" class="solid-background">
              <mat-label>{{ 'common.labels.name' | translate }}</mat-label>
              <input test-id="name-filter" type="text" matInput [formControl]="$any(filterFields.get('name'))" autocomplete="off">
            </mat-form-field>
          </th>
          <td test-id="user-name" mat-cell *matCellDef="let row">
            <app-avatar [users]="row.user" [enablePopover]="false" [enableAnimation]="true"></app-avatar>
            <span class="ellipsis-block" style="display: inline">
              {{ row.user.firstname }} <strong>{{ row.user.lastname }}</strong>
            </span>
          </td>
        </ng-container>
        <ng-container matColumnDef="email">
          <th data-id="email" mat-header-cell *matHeaderCellDef>
            <mat-form-field appearance="outline" class="solid-background">
              <mat-label>{{ 'common.labels.email' | translate }}</mat-label>
              <input test-id="email-filter" type="text" matInput [formControl]="$any(filterFields.get('email'))" autocomplete="off">
            </mat-form-field>
          </th>
          <td test-id="user-email" mat-cell *matCellDef="let row">
            {{ row.user._id }}
          </td>
        </ng-container>
        <ng-container matColumnDef="roles">
          <th data-id="roles" mat-header-cell *matHeaderCellDef>
            <mat-form-field appearance="outline" class="solid-background">
              <mat-label>{{ 'common.labels.roles' | translate }}</mat-label>
              <input test-id="roles-filter" type="text" matInput [formControl]="$any(filterFields.get('roles'))" autocomplete="off">
            </mat-form-field>
          </th>
          <td test-id="user-role" mat-cell *matCellDef="let row">
            <mat-form-field *ngIf="editable" class="solid-background" appearance="outline">
              <mat-select test-id="user-role-select" [placeholder]="'fwContainerPermissions.roles' | translate"
                [disabled]="row.user.disabled" [multiple]="!isAccess" [(value)]="row.role_ids"
                (openedChange)="update(row.user, row.role_ids, $event)">
                <mat-option *ngFor="let option of permissionOptions" [disabled]="$any(option).disabled"
                  [attr.test-id]="'role-select-option-' + option.label" [value]="option.value">
                  {{ option.label || option.value }}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <span *ngIf="!editable">{{ row.label }}</span>
          </td>
        </ng-container>
        <ng-container matColumnDef="access">
          <th data-id="access" mat-header-cell *matHeaderCellDef>
            <mat-form-field appearance="outline" class="solid-background">
              <mat-label>{{ 'common.labels.role' | translate }}</mat-label>
              <input test-id="access-filter" type="text" matInput [formControl]="$any(filterFields.get('access'))" autocomplete="off">
            </mat-form-field>
          </th>
          <td test-id="user-access" mat-cell *matCellDef="let row">
            <mat-form-field *ngIf="editable" class="solid-background" appearance="outline">
              <mat-select test-id="user-access-select" [placeholder]="'fwContainerPermissions.roles' | translate"
                [disabled]="row.user.disabled" [multiple]="!isAccess" [(value)]="row.access"
                (openedChange)="update(row.user, row.access, $event)">
                <mat-option *ngFor="let option of permissionOptions" [disabled]="$any(option).disabled"
                  [attr.test-id]="'access-select-option-' + option.label" [value]="option.value">
                  {{ option.label || option.value }}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <span *ngIf="!editable">{{ row.label }}</span>
          </td>
        </ng-container>
        <ng-container matColumnDef="delete">
          <th data-id="roles" mat-header-cell *matHeaderCellDef></th>
          <td test-id="user-actions" mat-cell *matCellDef="let row" class="actions-cell">
            <div class="actions list-action-buttons">
              <button mat-icon-button
                class="small"
                test-id="user-delete"
                *ngIf="editable && !managedByLdap"
                [matTooltip]="'common.actions.remove' | translate"
                matTooltipPosition="above"
                (click)="delete(row.user)">
                <mat-icon>delete</mat-icon>
              </button>
            </div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="columns"></tr>
        <tr mat-row
          [ngClass]="{ disabled: row.user.disabled }"
          class="list-action-hover"
          [matTooltip]="row.user.disabled ? ('fwContainerPermissions.userDisabled' | translate) : ''"
          matTooltipPosition="above"
          *matRowDef="let row; columns: columns">
        </tr>
      </mat-table>
    </div>
    <mat-paginator [pageSize]="50" showFirstLastButtons></mat-paginator>
  </ng-container>
</ng-container>

<ng-template #loadingState>
  <div test-id="loading-state" class="blank-state">
    <img src="/assets/images/loading.svg">
    <p>{{ 'common.labels.loading' | translate }}</p>
  </div>
</ng-template>

<ng-template #emptyState>
  <div class="blank-state">
    <mat-icon class="sm raised blue">person</mat-icon>
    <p>{{ 'fwContainerPermissions.states.empty' | translate }}</p>
  </div>
</ng-template>
